import { FC } from "react";
import { useTranslation } from "react-i18next";
import WhatsNewCard from "pages/releaseNotes/WhatsNewCard";
import {
  useOverviewEmissions,
  useLastUpload,
  useDataQualityCount,
  useOverviewRegions,
} from "./overviewData";
import DashboardHero from "./components/DashboardHero";
import StatusKpis from "./components/StatusKpis";
import EmissionsSection from "./components/EmissionsSection";
import EmissionsMapSection from "./components/EmissionsMapSection";
import ChartErrorBoundary from "pages/cpiReports/ChartErrorBoundary";
import QuickActions from "./components/QuickActions";
import WebinarsSection from "./components/WebinarsSection";
import TemplatesSection from "./components/TemplatesSection";
import "./Overview.scss";

const Overview: FC = () => {
  const { t } = useTranslation();
  const { dashboard, byMonth, period } = useOverviewEmissions();
  const lastUpload = useLastUpload();
  const dqCount = useDataQualityCount();
  const regions = useOverviewRegions();

  return (
    <div className="container overview">
      <DashboardHero period={period} />

      <h2 className="overview__section-label">{t("dashboard.dataStatus")}</h2>
      <StatusKpis
        dashboard={dashboard}
        lastUpload={lastUpload}
        dqCount={dqCount}
      />

      <h2 className="overview__section-label">{t("dashboard.emissions")}</h2>
      <EmissionsSection dashboard={dashboard} byMonth={byMonth} />

      <h2 className="overview__section-label">
        {t("dashboard.whereEmissionsStart", "Where emissions start")}
      </h2>
      {/* Same boundary as the full map on /cpi-reports: this mini-map reads the
          same /cpi/regions response, so it carries the same crash risk, and a
          failure here must not take down the rest of the dashboard with it. */}
      <ChartErrorBoundary>
        <EmissionsMapSection regions={regions} />
      </ChartErrorBoundary>

      <h2 className="overview__section-label">{t("dashboard.quickActions")}</h2>
      <QuickActions />

      <h2 className="overview__section-label">{t("dashboard.webinars")}</h2>
      <WebinarsSection />

      <h2 className="overview__section-label">{t("dashboard.templates")}</h2>
      <TemplatesSection />

      <h2 className="overview__section-label">{t("releaseNotes")}</h2>
      <div className="overview__whatsnew">
        <WhatsNewCard />
      </div>
    </div>
  );
};

export default Overview;
